import React from "react";
import { injectIntl } from "react-intl";
import AttendeeRepository from "../../repository/AttendeeRepository";
import StandardFormComponent from "../basics/form/StandardFormComponent";
import { withRouter } from 'react-router-dom';
import FormToastComponent from "../basics/FormToastComponent";
import FormHelper from "../../helpers/FormHelper";
import CheckPermissions from "../../helpers/CheckPermissions";
import UserRolesEnum from "../../enums/UserRolesEnum";
import AttendeeTextFormComponent from "./forms/AttendeeTextFormComponent";
import Module from "../../models/module/Module";
import Attendee from "../../models/attendee/Attendee";
import { ClientRepository, ModuleRepository, WebsiteRepository } from "../../repository";
import { LoaderComponent } from "../basics/layout";
import Website from "../../models/website/Website";
import { CountryHelper } from "../../helpers";
import * as Yup from "yup"
import ClientHelper from "../../helpers/ClientHelper";

class AttendeeFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lng: props.match.params.language,
            module: Module.get(),
            model: this.props.model !== undefined ? this.props.model : new Attendee(),
            loading: true,
            settings: {},
            isEdit: false,
            roles: this.props.user.roles,
        };

        this.table_ref = React.createRef();

        this.customProps = { ...this.props };
        this.isManager = CheckPermissions.role(this.state.roles, UserRolesEnum.MANAGER) && !CheckPermissions.role(this.state.roles, UserRolesEnum.RESELLER);
    }

    componentDidMount() {
        let promises = [
            ModuleRepository.getSettings(),
            WebsiteRepository.get(Website.get()),
            ModuleRepository.get(this.state.module.id),
            ClientRepository.all()
        ];

        if (this.props.get_promise !== undefined) {
            promises.push(this.props.get_promise);
        }

        Promise.all(promises)
            .then(result => {
                let moduleSettingsResult = result[0];
                let websiteGetResult = result[1];
                let moduleGetResult = result[2];
                let clientAllResults = result[3];
                let promiseGetResult = result[4];

                let settings = {};
                if (moduleSettingsResult !== undefined && moduleSettingsResult.data !== undefined) {
                    settings = moduleSettingsResult.data.settings;
                }

                let currentModule = this.state.module;
                currentModule.module = moduleGetResult.module;
                Module.set(currentModule);

                if (clientAllResults !== undefined) {
                    let clients = [];
                    clientAllResults.forEach(c => clients.push({ value: c.id, label: c.fullname() }))
                    settings.clients = clients;
                }

                let model = this.state.model;
                if (promiseGetResult !== undefined) {
                    model = Attendee.fromJson(promiseGetResult.attendee);

                    model = Module.fillModel(this.state.module, this.state.lng, model);
                }

                if (websiteGetResult !== undefined) {
                    if (!model.language) model.language = websiteGetResult.default_language;

                    let languages = [];
                    websiteGetResult.languages.forEach(language => {
                        languages.push({ value: language.language, label: CountryHelper.getLanguages().find(({ value }) => value + "" === language.language + "").label })
                    });
                    settings.languages = languages;
                }
                
                this.setState({
                    loading: false,
                    settings: settings,
                    model: model,
                    module: Module.get(),
                    lng: this.state.lng ? this.state.lng : websiteGetResult.default_language,
                    isEdit: model.id
                });
            });
    }

    schema = () => {
        let { settings } = this.state;

        let fields = {
            client: Yup.string().required('CMS.Attendee.Content.Form.client'),
            first_name: Yup.string().required('CMS.Attendee.Content.Form.first_name').max(100, 'CMS.Attendee.Content.Form.first_name|100|max').matches(/^[A-z\u00C0-\u00ff' -]+$/, 'CMS.Attendee.Content.Form.first_name|letter', { excludeEmptyString: true }),
            last_name: Yup.string().required('CMS.Attendee.Content.Form.last_name').max(100, 'CMS.Attendee.Content.Form.last_name|100|max').matches(/^[A-z\u00C0-\u00ff' -]+$/, 'CMS.Attendee.Content.Form.first_name|letter', { excludeEmptyString: true })
        };

        if (settings.fields?.email) {
            fields.email = Yup.string().required('CMS.Attendee.Content.Form.email').email('CMS.Attendee.Content.Form.email|invalidemail').max(100, 'CMS.Attendee.Content.Form.email|100|max');
        }
        if (settings.fields?.birth_date) {
            fields.birth_date = Yup.date().max(new Date(), 'CMS.Attendee.Content.Form.birth_date|max_date').nullable();
        }
        if (settings.fields?.national_insurance_number) {
            fields.national_insurance_number = Yup.string().max(50, 'CMS.Attendee.Content.Form.national_insurance_number|50|max').test(
                'is-nin-valid',
                'CMS.Client.Content.Form.national_insurance_number|invalid',
                (value, context) => ClientHelper.validateNationalInsuranceNumber(value)
            ).nullable();
        }

        if (settings.fields?.phone) {
            fields.phone = Yup.string().phone('BE', 'CMS.Attendee.Content.Form.phone|phone').nullable();
        }

        fields = Module.validateAdditionalField(this.state.module, this.state.lng, fields);

        return Yup.object().shape(fields);
    }

    render() {
        if (this.state.loading) return <LoaderComponent />;

        return (
            <StandardFormComponent
                {...this.customProps}
                ref={this.table_ref}
                parent={this}
                className="attendee"
                validationSchema={this.schema}
                model={this.state.model}
                formSubmit={(values, formikActions) => {
                    if (this.state.isEdit) {
                        return AttendeeRepository.update({ id: values.id, ...values })
                            .then(() => {
                                FormToastComponent.successTrans("Attendee", "Default.saved");
                                this.props.history.push('/module/' + this.props.slug + '/' + Module.getId() + '/overview');
                            })
                            .catch(error => FormHelper.handleSubmitError(this, error))
                    } else {
                        return AttendeeRepository.create({ ...values, ...{ source: 'console' } })
                            .then(() => {
                                FormToastComponent.successTrans("Attendee", "Default.saved");
                                this.props.history.push('/module/' + this.props.slug + '/' + Module.getId() + '/overview');
                            })
                            .catch(error => FormHelper.handleSubmitError(this, error))
                    }
                }}
                formErrors={this.state.form_errors}
                fields={AttendeeTextFormComponent.fields(this.state, this)}
            />
        );
    }
}

export default withRouter(injectIntl(AttendeeFormComponent));